<template>
  <v-app
  :class="[$router.currentRoute.name]"
  id="app"
  >
    <v-app-bar
      app
      color="#223573"
      dark
      flat
      justify="center"
    >
      <v-app-bar-nav-icon dark @click="drawer = !drawer" ></v-app-bar-nav-icon>
      <v-img
          :src="mainLogo.src"
          class="logo-image"
          contain
          height="33"
          center
          @click="goHome"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular small indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      <v-app-bar-nav-icon disabled dark @click="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      temporary
      color="#407FC2"
    >
      <v-list>

        <v-list-item
          v-for="(item, i) in navLinks"
          :key="i"
          :to="item.path"
          link
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.navTitle }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list-item href="https://www.teamgb.com/" target="_blank">
        <v-list-item-content>
          <v-list-item-title>
            About Team GB
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-row>
        <v-col cols="12" >
          <v-img
            :src="navLogo.src"
            height="130"
            max-width="90%"
            contain
            class="center"
          >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular small indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
          </template>
          </v-img>
        </v-col>
      </v-row>
      
       
    </v-navigation-drawer>
    <v-content>
      <component v-bind:is="currentComponent" v-bind:is-desktop="isDesktop"></component>
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import Footer from './components/Footer'
import Early from './views/tooSoon'
import Late from './views/tooLate'
export default {
  name: 'App',
  created() {
    this.routes = this.$router.options.routes
    window.addEventListener('resize', this.onResize)
  },
  mounted() {
    this.mainFocus()
    this.init()
    //this.currentComponent = 'router-view'
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  components: {
    Footer,
    Early,
    Late
  },
  data: () => ({
    drawer: false,
    items: [
      { title: 'Home', icon: 'dashboard' },
      { title: 'About', icon: 'question_answer' },
    ],
    routes: [],
    navLogo: {src:require('./assets/logo-lockup.png')},
    mainLogo: {src:require('./assets/mcvities-logo.png')},
    currentComponent: '',
    siteStatus: 0
  }),
  methods: {
    goHome: function () {
      this.$router.push('/')
    },
    init: function () { 
      this.axios.get('/api/getSiteStatus').then((response)=>{
        console.log(response);
        if(response.data.success) {
          this.siteStatus = response.data.payload.stateCode
          // Site status 1 - Site not yet open
          if(response.data.payload.stateCode == 1) {
            if(this.$router.currentRoute.name=='terms' || this.$router.currentRoute.name=='faq' || this.$router.currentRoute.name=='privacy') {
              this.currentComponent = 'router-view'
            }else{
              this.currentComponent =  'Early'// 'router-view'
            }
          }else if(response.data.payload.stateCode == 3) {
            // site status 3 - site now closed
            if(this.$router.currentRoute.name=='terms' || this.$router.currentRoute.name=='faq' || this.$router.currentRoute.name=='privacy') {
              this.currentComponent = 'router-view'
            }else{
              this.currentComponent =  'Late'// 'router-view'
            }
          }else {
            this.currentComponent = 'router-view'
          }
        }
      })

      
    },
    mainFocus: function () {
      var anchor = window.location.href.substring(window.location.href.lastIndexOf("/")+1)
      var thing = this
      setTimeout((function() {
        var tgt = '#page-heading'
        if(anchor.indexOf('#')!= -1) {
          tgt = anchor
        }
        thing.$scrollTo(tgt, 300, {offset:-120})
      }), 3000)
    },
    onResize: function () {
      if (window.innerWidth > 768) {
        //this.isDesktop = true
      } else {
        //this.isDesktop = false
      }
    }
  },
  computed: {
     navLinks: function() {
       return this.routes.filter(function(u) {
         return u.nav
        })
     },
     isDesktop: function () {
      if (window.innerWidth > 768) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    $route: function (){
      this.mainFocus()
      console.log(this.siteStatus)
      if(this.siteStatus==1) {
        // site status 1 - site not yet open
        if(this.$route.name=='terms' || this.$route.name=='faq' || this.$route.name=='privacy') {
          this.currentComponent = 'router-view'
        }else{
          this.currentComponent =  'Early'// 'router-view'
        }
      }else if(this.siteStatus==3) {
        // site status 3 - site now closed
        if(this.$route.name=='terms' || this.$route.name=='faq' || this.$route.name=='privacy') {
          this.currentComponent = 'router-view'
        }else{
          this.currentComponent =  'Late'// 'router-view'
        }
      }else {
        this.currentComponent = 'router-view'
      }
      
    },
  }
};
</script>
